import styled from "@emotion/styled/macro";
import { HelpCenter } from "../organisms/HelpCenter";

const Headline = styled.div`
  display: flex;
  font-family: Roobert;
  justify-content: space-between;
  align-items: center;
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  margin-bottom: 44px;
`;

const Container = styled.div`
  margin: 5%;
  width: 90%;
`;

const SupportPage = () => {
  return (
    <div className="App" data-testid="support-page">
      <Container>
        <Headline>
          <p style={{ margin: 0 }}>Help Center</p>
        </Headline>
        <HelpCenter />
      </Container>
    </div>
  );
};

export { SupportPage };
